import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Icon, Image } from '@uncinc/uncinc-react-kitchen-sink';

import type { SearchAllContentDefaultProfileHit as Type } from '../../../../SearchAllContent/types';
import { constructImageSourcesArray } from '../../../../../helpers/constructImageSources';
import useLayoutVariables from '../../../../../hooks/useLayoutVariables';

import Card from '../../../../Card';

import './style.scss';

const MetaSearchProfileHit: React.FC<{ hit: Type }> = ({ hit }) => {
  const classes = classNames('MetaSearchHit', 'MetaSearchProfileHit');

  const { t } = useTranslation();

  const {
    heroImageAspectRatio,
  } = useLayoutVariables('profileTeaser');

  const fullName = [hit.first_name[0], hit.last_name?.[0]].join(' ');

  return (
    <Card className={classes}>
      <Card.Content>
        <Card.Image
          image={(
            <Image
              src={constructImageSourcesArray(hit, heroImageAspectRatio)}
              alt={hit.profile_image_alt?.[0]}
              lazyload={false}
            />
          )}
        />

        <div className="MetaSearchProfileHit__text-wrapper">
          <div className="Card__content__body">
            <Card.Link link={hit.url[0]}>
              <Card.Title title={fullName} />
            </Card.Link>
          </div>

          <div className="Card__content__metadata">
            {hit.profile_functions_name?.[0] && (
              <div className="MetaSearchProfileHit__functions">
                <Card.Subtitle
                  subtitle={(
                    <>
                      {hit.profile_functions_name.map((function_name, i) => (
                        <span>
                          {function_name}
                          {hit.profile_functions_name && i < hit.profile_functions_name.length - 1 && ', '}
                        </span>
                      ))}
                    </>
                  )}
                />
              </div>
            )}
            {hit.profile_locations_name?.[0] && (
              <div className="MetaSearchProfileHit__locations">
                <Card.Subtitle
                  subtitle={(
                    <>
                      {hit.profile_locations_name.map((location, i) => (
                        <span>
                          {location}
                          {hit.profile_locations_name && i < hit.profile_locations_name.length - 1 && ', '}
                        </span>
                      ))}
                    </>
                  )}
                />
              </div>
            )}
            {hit.profile_address?.[0] && (
              <div className="MetaSearchProfileHit__countries">
                <Card.Subtitle
                  subtitle={(
                    <>
                      {hit.profile_address.map((address, i) => (
                        <span>
                          {t(`countries:${address}`)}
                          {hit.profile_address && i < hit.profile_address.length - 1 && ', '}
                        </span>
                      ))}
                    </>
                  )}
                />
              </div>
            )}
          </div>
        </div>

        <Icon className="Card__icon" name="arrow_forward" flair="outlined" />
      </Card.Content>
    </Card>
  );
};

export default MetaSearchProfileHit;
